import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Dashboard from "./components/dashboard";
import Footer from "./components/Layouts/footer";
import Sidebar from "./components/Layouts/sidebar";
import Topnav from "./components/Layouts/TopNav";
import StudentAdd from "./components/student/studentAdd";
import Modules from "./Pages/question-paper/Modules";
import Course from "./Pages/question-paper/Course";
import Subject from "./Pages/question-paper/Subject";
import Chapter from "./Pages/question-paper/Chapter";
import Topic from "./Pages/settings/Topic";
import Level from "./Pages/settings/Level";
import QuestionType from "./Pages/settings/QuestionType";
import ExamType from "./Pages/settings/ExamType";
import AddQuestion from "./Pages/questions/AddQuestion";
import StudentDetails from "./Pages/students/StudentDetails";
import SectionDetails from "./Pages/students/SectionDetails";
import StaffDetails from "./Pages/staff/StaffDetails";
import QuestionDetails from "./Pages/questions/QuestionDetails";
import Login from "./Pages/Login";
import SignUp from "./Pages/SignUp";
import "./App.css";
import ForgotPassword from "./Pages/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword";
import PrivateRoute from "./PrivateRoute";
import PaperDetails from "./Pages/paper/PaperDetails";
import ExamplePage from "./Pages/paper/ExamplePage";
import ImportQuestion from "./Pages/questions/ImportQuestion";
import Template from "./Pages/paper/Template";
import TemplateDetails from "./Pages/paper/TemplateDetails";
import PickQuestions from "./Pages/paper/PickQuestions";
import ViewPaper from "./Pages/paper/ViewPaper";
import ChapterList from "./Pages/paper/ChapterList";
import Role from "./Pages/staff/Role";
import Ex from "./Pages/paper/Ex";
import Permissions from "./Pages/staff/Permissions";
import Settings from "./Pages/settings/Settings";
import StaffNRole from "./Pages/staff/StaffNRole";
import QuestionDetailsVerify from "./Pages/questions/QuestionDetailsVerify";
import { Question } from "@phosphor-icons/react";
import Questions from "./Pages/questions/Questions";
import PickQuestionImport from "./Pages/paper/PickQuestionImport";
import PaperImport from "./Pages/questions/PaperImport";
import PreviousPaper from "./Pages/paper/PreviousPaper";
import Random from "./Pages/paper/Random";
import Profile from "./Pages/Profile";
import Attempted from "./Pages/paper/Attempted";
import ViewResult from "./Pages/paper/ViewResult";
import Performance from "./Pages/students/Performance";
import SidebarMob from "./components/Layouts/SidebarMob";
import AttemptedStudent from "./Pages/students/AttemptedStudent";
import QuestionsEx from "./Pages/questions/QuestionsEx";
import Example from "./Pages/questions/Example";
import PdfToLatex from "./Pages/converter/PdfToLatex";
import AdminDashboard from "./components/AdminDashboard";
import StudentData from "./components/StudentData";
import PaperAnalysis from "./Pages/paper/PaperAnalysis";
import StudentOverall from "./Pages/paper/StudentOverall";
import PaperOverview from "./Pages/paper/PaperOverview";
import ImportOMR from "./Pages/paper/ImportOMR"
import VerifyAnswer from "./Pages/paper/VerifyAnswer";
import LeaderBoard from "./Pages/paper/LeaderBoard";
import PracticeQuestions from "./Pages/questions/PracticeQuestions";
import AdminDashboard2 from "./components/AdminDashboard2";
import ChapterAnalysis from "./components/ChapterAnalysis";
import Sections from "./Pages/question-paper/Sections";
import Details from "./components/Layouts/Details";

const App = () => {
  const location = useLocation();

  useEffect(() => {
  const name = localStorage.getItem("companyName");

  if (name) {
    document.title = name;
  }
}, []);

  // Define paths where Sidebar and Topnav should not be displayed
  const isAuthPage = () => {
    const authPages = [
      "/login",
      "/signup",
      "/forgot-password",
      "/reset-password",
      "/example-details",
    ];

    // Check if pathname matches any of the authPages
    if (authPages.includes(location.pathname)) {
      return true;
    }

    const dynamicRoutes = [
      /^\/view-questions\/\d+$/,
      /^\/previous-paper\/\d+$/,
    ]; // Matches "/view-questions/123"
    for (let regex of dynamicRoutes) {
      if (regex.test(location.pathname)) {
        return true;
      }
    }

    return false;
  };

  return (
    <div>
      <div className="App">
        <div className="preloader">
          <div className="loader"></div>
        </div>
        <div className="side-overlay"></div>
        {!isAuthPage() && <Sidebar />}
        <div
          className={`dashboard-main-wrapper ${isAuthPage() ? "auth-wrapper" : ""
            }`}
        >
          {!isAuthPage() && <Topnav />}
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/details" element={<Details />} />

            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Navigate to="/admin-dashboard2" />
                </PrivateRoute>
              }
            />

            <Route
              path="/pdf-latex"
              element={
                <PrivateRoute>
                  <PdfToLatex />
                </PrivateRoute>
              }
            />

            <Route
              path="/import-omr/:id"
              element={
                <PrivateRoute>
                  <ImportOMR />
                </PrivateRoute>
              }
            />


            <Route
              path="/admin-dashboard"
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />

            <Route
              path="/admin-dashboard2"
              element={
                <PrivateRoute>
                  <AdminDashboard2 />
                </PrivateRoute>
              }
            />

            <Route
              path="/student-list"
              element={
                <PrivateRoute>
                  <StudentDetails />
                </PrivateRoute>
              }
            />

            <Route
              path="/chapter-analysis/:id"
              element={
                <PrivateRoute>
                  <ChapterAnalysis />
                </PrivateRoute>
              }
            />

            <Route
              path="/sections"
              element={
                <PrivateRoute>
                  <Sections />
                </PrivateRoute>
              }
            />




            <Route
              path="/verify-answers/:id"
              element={
                <PrivateRoute>
                  <VerifyAnswer />
                </PrivateRoute>
              }
            />

            <Route
              path="/paper-overview/:id"
              element={
                <PrivateRoute>
                  <PaperOverview />
                </PrivateRoute>
              }
            />


            <Route
              path="/paper-analysis/:id"
              element={
                <PrivateRoute>
                  <PaperAnalysis />
                </PrivateRoute>
              }
            />


            <Route
              path="/student-overall/:id"
              element={
                <PrivateRoute>
                  <StudentOverall />
                </PrivateRoute>
              }
            />


            <Route
              path="/student-data"
              element={
                <PrivateRoute>
                  <StudentData />
                </PrivateRoute>
              }
            />

            <Route
              path="/example"
              element={
                <PrivateRoute>
                  <QuestionsEx />
                </PrivateRoute>
              }
            />

            <Route
              path="/dashboard/:id"
              element={
                <PrivateRoute>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/sidebar-mob"
              element={
                <PrivateRoute>
                  <SidebarMob />
                </PrivateRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Settings />
                </PrivateRoute>
              }
            />
            <Route
              path="/staff-role"
              element={
                <PrivateRoute>
                  <StaffNRole />
                </PrivateRoute>
              }
            />
            <Route
              path="/question-details-verify"
              element={
                <PrivateRoute>
                  <QuestionDetailsVerify />
                </PrivateRoute>
              }
            />
            <Route
              path="/studentAdd"
              element={
                <PrivateRoute>
                  <StudentAdd />
                </PrivateRoute>
              }
            />

            <Route
              path="/ex"
              element={
                <PrivateRoute>
                  <Example />
                </PrivateRoute>
              }
            />

            <Route
              path="/attempted"
              element={
                <PrivateRoute>
                  <AttemptedStudent />
                </PrivateRoute>
              }
            />
            <Route
              path="/modules"
              element={
                <PrivateRoute>
                  <Modules />
                </PrivateRoute>
              }
            />
            <Route
              path="/course"
              element={
                <PrivateRoute>
                  <Course />
                </PrivateRoute>
              }
            />
            <Route
              path="/subject"
              element={
                <PrivateRoute>
                  <Subject />
                </PrivateRoute>
              }
            />
            <Route
              path="/chapter"
              element={
                <PrivateRoute>
                  <Chapter />
                </PrivateRoute>
              }
            />
            <Route
              path="/topic"
              element={
                <PrivateRoute>
                  <Topic />
                </PrivateRoute>
              }
            />
            <Route
              path="/level"
              element={
                <PrivateRoute>
                  <Level />
                </PrivateRoute>
              }
            />
            <Route
              path="/question-type"
              element={
                <PrivateRoute>
                  <QuestionType />
                </PrivateRoute>
              }
            />
            <Route
              path="/exam-type"
              element={
                <PrivateRoute>
                  <ExamType />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-question/:id"
              element={
                <PrivateRoute>
                  <AddQuestion />
                </PrivateRoute>
              }
            />
            <Route
              path="/add-question"
              element={
                <PrivateRoute>
                  <AddQuestion />
                </PrivateRoute>
              }
            />
            <Route
              path="/import-question"
              element={
                <PrivateRoute>
                  <ImportQuestion />
                </PrivateRoute>
              }
            />
            <Route
              path="/previous-paper/:id"
              element={
                <PrivateRoute>
                  <PreviousPaper />
                </PrivateRoute>
              }
            />
            <Route
              path="/paper-import/:id"
              element={
                <PrivateRoute>
                  <PaperImport />
                </PrivateRoute>
              }
            />
            <Route
              path="/question-details"
              element={
                <PrivateRoute>
                  <QuestionDetails />
                </PrivateRoute>
              }
            />

            <Route
              path="/practice-questions"
              element={
                <PrivateRoute>
                  <PracticeQuestions />
                </PrivateRoute>
              }
            />
            <Route
              path="/questions"
              element={
                <PrivateRoute>
                  <Questions />
                </PrivateRoute>
              }
            />
            <Route
              path="/pick-question-import/:id"
              element={
                <PrivateRoute>
                  <PickQuestionImport />
                </PrivateRoute>
              }
            />

            <Route
              path="/leaderboard"
              element={
                <PrivateRoute>
                  <LeaderBoard />
                </PrivateRoute>
              }
            />
            <Route
              path="/student-details"
              element={
                <PrivateRoute>
                  <AttemptedStudent />
                </PrivateRoute>
              }
            />
            <Route
              path="/section-details"
              element={
                <PrivateRoute>
                  <SectionDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/staff-details"
              element={
                <PrivateRoute>
                  <StaffDetails />
                </PrivateRoute>
              }
            />

            <Route
              path="/chapter-list/:id"
              element={
                <PrivateRoute>
                  <ChapterList />
                </PrivateRoute>
              }
            />

            <Route
              path="/pick-questions/:id"
              element={
                <PrivateRoute>
                  <PickQuestions />
                </PrivateRoute>
              }
            />
            <Route
              path="/view-questions/:id"
              element={
                <PrivateRoute>
                  <ViewPaper />
                </PrivateRoute>
              }
            />
            <Route
              path="/paper-details"
              element={
                <PrivateRoute>
                  <PaperDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/template"
              element={
                <PrivateRoute>
                  <Template />
                </PrivateRoute>
              }
            />
            <Route
              path="/template/:id"
              element={
                <PrivateRoute>
                  <Template />
                </PrivateRoute>
              }
            />
            <Route
              path="/template-details"
              element={
                <PrivateRoute>
                  <TemplateDetails />
                </PrivateRoute>
              }
            />
            <Route
              path="/example-details"
              element={
                <PrivateRoute>
                  <ExamplePage />
                </PrivateRoute>
              }
            />
            <Route
              path="/role"
              element={
                <PrivateRoute>
                  <Role />
                </PrivateRoute>
              }
            />
            <Route
              path="/permissions/:id"
              element={
                <PrivateRoute>
                  <Permissions />
                </PrivateRoute>
              }
            />
            <Route
              path="/random/:id"
              element={
                <PrivateRoute>
                  <Random />
                </PrivateRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path="/attempted-list/:id"
              element={
                <PrivateRoute>
                  <Attempted />
                </PrivateRoute>
              }
            />
            <Route
              path="/view-result/:paperId/:studentId/:examRecordId"
              element={
                <PrivateRoute>
                  <ViewResult />
                </PrivateRoute>
              }
            />
            <Route
              path="/performance/:id"
              element={
                <PrivateRoute>
                  <Performance />
                </PrivateRoute>
              }
            />
            <Route
              path="/ex"
              element={
                <PrivateRoute>
                  <Ex />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/permissions"
              element={
                <PrivateRoute>
                  <Permissions />
                </PrivateRoute>
              }
            /> */}

            {/* Fallback Route */}
            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {/* <Route path="/paper-deatils" element={<PaperDetails />} /> */}
          </Routes>
          {!isAuthPage() && <Footer />}
        </div>
      </div>
    </div>
  );
};

export default App;
